import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationService } from '../../../navigation/navigation.service';
import { IIcon } from './icon.interface';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-icon',
  templateUrl: 'icon.component.html',
  styleUrls: ['icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnInit, OnDestroy {
  @Input() icon: IIcon;

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  locationPath: string;

  constructor(
    private _navigationService: NavigationService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.locationPath = this._navigationService.getCurrentUrl();

    this._navigationService.navigationEnds$
      .pipe(takeUntil(this._destroyed))
      .subscribe((url) => {
        this.locationPath = url;

        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
